export default "__VITE_ASSET__BthYMxFB__"